import {createEmitter} from './factory';

export const Emitter = createEmitter();
